export class ListClassificationPoliciesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "classificationPolicies",
            "baseName": "classificationPolicies",
            "type": "Array<ClassificationPolicy>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListClassificationPoliciesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
